import Vue from 'vue'

const initialState = {
  list: [],
  relations: {},
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getList({commit}, {actionType, params}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`moderator/${actionType}/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data.results})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, {actionType, id}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`moderator/${actionType}/${id}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, {actionType, payload}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`moderator/${actionType}/`, payload).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, {actionType, payload}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`moderator/${actionType}/${payload.id}/`, payload).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    changePassword({commit}, {id, password}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`moderator/employees/${id}/change_password/`, {new_password: password}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations ({commit}, {actionType, id=null}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.get(`moderator/${actionType}/relations/`, {params: {id}}).then((response) => {
          commit('SET', {key: 'relations', val: response.data})
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    addExecutor({commit}, {employeeId, executorId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`moderator/employees/${employeeId}/executors/`, {
          employee: executorId
        }).then((response) => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeExecutor({commit}, {employeeId, executorId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`moderator/employees/${employeeId}/executors/${executorId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
  }
}
